export default {
  name: "DigitalSignageBundleNew",
  props: {
    settings: null,
    arecheckedesdisabled: Boolean,
    facility: null
  },
  created() {
    this.sendDefaultValueForModule();
  },
  computed: {
    isDisable(): boolean {
      return !this.facility.featureDigitalSignage;
    },
    digitalSignageCategory: {
      get() {
        return (
          (this.facility.featureDigitalSignage ?? true) &&
          (this.facility.noticeboardEnabled ?? true) &&
          (this.facility.isStaffHubDevicesColumnDigitalSignage ?? true)
        );
      }
    },
  },
  methods: {
    sendDefaultValueForModule() {
      this.$emit('send-bundle-value', this.digitalSignageCategory)
    },
    digitalSignageBundleUpdate(value) {
      this.digitalSignageCategoryUpdate(value);
    },
    digitalSignageCategoryUpdate(value) {
      this.facility.featureDigitalSignage = value;
      this.facility.noticeboardEnabled = value;
      this.facility.isStaffHubDevicesColumnDigitalSignage = value;

      if(value) {
        this.$emit('send-bundle-value', this.digitalSignageCategory)
      }
    },
  }
}